(() => {
  /**
   * Handle the 2 chests
   */
  class Chests extends PIXI.Container {
    constructor() {
      super();
      this._leftChestAnimations = {
        silver: null,
        gold: null,
      };
      this._rightChestAnimations = {
        silver: null,
        gold: null,
      };
      this._leftBonusChestAnimations = {
        silver: null,
        gold: null,
      };
      this._rightBonusChestAnimations = {
        silver: null,
        gold: null,
      };

      this._leftChestAssets = {
        burst: null,
        burstShowing: false,
        sixFreeSpins: null,
        twelveFreeSpins: null,
      };

      this._rightChestAssets = {
        burst: null,
        burstShowing: false,
        sixFreeSpins: null,
        twelveFreeSpins: null,
      };

      this._leftBonusChestAssets = {
        burst: null,
        burstShowing: false,
        sixFreeSpins: null,
        twelveFreeSpins: null,
      };

      this._rightBonusChestAssets = {
        burst: null,
        burstShowing: false,
        sixFreeSpins: null,
        twelveFreeSpins: null,
      };

      this._leftActive = false;
      this._rightActive = false;
      this._leftBonusActive = false;
      this._rightBonusActive = false;
      this._currentLeftFsAsset = null;
      this._currentRightFsAsset = null;
      this._currentLeftBonusFsAsset = null;
      this._currentRightBonusFsAsset = null;
      this._leftFsAssetTween = null;
      this._rightFsAssetTween = null;
      this._leftBonusFsAssetTween = null;
      this._rightBonusFsAssetTween = null;

      this._sizeScales = {
        1: 0.28,
        2: 0.32,
        3: 0.36,
        4: 0.4,
        5: 0.44,
      };

      this._chestColours = {
        0: "silver",
        1: "gold",
      };

      // default chest states
      this._currentStates = {
        left: { colour: 0, size: 1 },
        right: { colour: 0, size: 1, silverBeforeGB: false },
        leftBonus: { colour: 0, size: 5 },
        rightBonus: { colour: 0, size: 5 },
      };

      this._wigglingChest = false;

      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Setup all of the left and right chest assets
     */
    initialise() {
      this._leftChestAnimations = {
        silver: resourceManager.createObject(
          "movie",
          "leftChestSilver",
          `${this.name}:leftChestContainer:chestAnimationContainer`,
          {
            definition: "silverChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: -0.3,
            scaleY: 0.3,
            loop: false,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "leftChestGold",
          `${this.name}:leftChestContainer:chestAnimationContainer`,
          {
            definition: "goldChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: -0.3,
            scaleY: 0.3,
            loop: false,
          }
        ),
      };

      this._leftChestAnimations.silver.gotoAndStop(0);
      this._leftChestAnimations.gold.gotoAndStop(0);
      this._leftChestAnimations.silver.visible = false;
      this._leftChestAnimations.gold.visible = false;

      this._rightChestAnimations = {
        silver: resourceManager.createObject(
          "movie",
          "rightChestSilver",
          `${this.name}:rightChestContainer:chestAnimationContainer`,
          {
            definition: "silverChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: 0.3,
            scaleY: 0.3,
            loop: false,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "rightChestGold",
          `${this.name}:rightChestContainer:chestAnimationContainer`,
          {
            definition: "goldChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: 0.3,
            scaleY: 0.3,
            loop: false,
          }
        ),
      };

      this._rightChestAnimations.silver.gotoAndStop(0);
      this._rightChestAnimations.gold.gotoAndStop(0);
      this._rightChestAnimations.silver.visible = false;
      this._rightChestAnimations.gold.visible = false;

      this._leftBonusChestAnimations = {
        silver: resourceManager.createObject(
          "movie",
          "leftBonusChestSilver",
          `${this.name}:leftBonusChestContainer:chestAnimationContainer`,
          {
            definition: "silverChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: -0.44,
            scaleY: 0.44,
            loop: false,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "leftBonusChestGold",
          `${this.name}:leftBonusChestContainer:chestAnimationContainer`,
          {
            definition: "goldChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: -0.44,
            scaleY: 0.44,
            loop: false,
          }
        ),
      };

      this._leftBonusChestAnimations.silver.gotoAndStop(0);
      this._leftBonusChestAnimations.gold.gotoAndStop(0);
      this._leftBonusChestAnimations.silver.visible = false;
      this._leftBonusChestAnimations.gold.visible = false;

      this._rightBonusChestAnimations = {
        silver: resourceManager.createObject(
          "movie",
          "rightBonusChestSilver",
          `${this.name}:rightBonusChestContainer:chestAnimationContainer`,
          {
            definition: "silverChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: 0.44,
            scaleY: 0.44,
            loop: false,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "rightBonusChestGold",
          `${this.name}:rightBonusChestContainer:chestAnimationContainer`,
          {
            definition: "goldChest",
            anchor: { x: 0.5, y: 1 },
            scaleX: 0.44,
            scaleY: 0.44,
            loop: false,
          }
        ),
      };

      this._rightBonusChestAnimations.silver.gotoAndStop(0);
      this._rightBonusChestAnimations.gold.gotoAndStop(0);
      this._rightBonusChestAnimations.silver.visible = false;
      this._rightBonusChestAnimations.gold.visible = false;

      this._leftChestAssets = {
        burst: resourceManager.get(`${this.name}:leftChestContainer:chestAssetsContainer:leftChestBurst`),
        sixFreeSpins: resourceManager.get(`${this.name}:leftChestContainer:chestAssetsContainer:leftChest6FreeSpins`),
        twelveFreeSpins: resourceManager.get(
          `${this.name}:leftChestContainer:chestAssetsContainer:leftChest12FreeSpins`
        ),
      };

      this._rightChestAssets = {
        burst: resourceManager.get(`${this.name}:rightChestContainer:chestAssetsContainer:rightChestBurst`),
        sixFreeSpins: resourceManager.get(`${this.name}:rightChestContainer:chestAssetsContainer:rightChest6FreeSpins`),
        twelveFreeSpins: resourceManager.get(
          `${this.name}:rightChestContainer:chestAssetsContainer:rightChest12FreeSpins`
        ),
      };

      this._leftBonusChestAssets = {
        burst: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChestBurst`),
        6: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChest6FreeSpins`),
        8: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChest8FreeSpins`),
        10: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChest10FreeSpins`),
        12: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChest12FreeSpins`),
        16: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChest16FreeSpins`),
        20: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChest20FreeSpins`),
        24: resourceManager.get(`${this.name}:leftBonusChestContainer:chestAssetsContainer:bonusChest24FreeSpins`),
      };

      this._rightBonusChestAssets = {
        burst: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChestBurst`),
        6: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChest6FreeSpins`),
        8: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChest8FreeSpins`),
        10: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChest10FreeSpins`),
        12: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChest12FreeSpins`),
        16: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChest16FreeSpins`),
        20: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChest20FreeSpins`),
        24: resourceManager.get(`${this.name}:rightBonusChestContainer:chestAssetsContainer:bonusChest24FreeSpins`),
      };

      this._retriggerPopup = this._spinsWon = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:retriggerPanel"
      );
      this._retriggerPopup.visible = false;
      this._spinsAwarded = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:retriggerPanel:numFreeSpinsText"
      );

      this._leftMaxChestGlowAnims = {
        silver: resourceManager.createObject(
          "movie",
          "leftMaxChestGlow",
          `${this.name}:leftChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlow",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: -0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "leftMaxChestGlowGold",
          `${this.name}:leftChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlowGold",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: -0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
      };
      this._rightMaxChestGlowAnims = {
        silver: resourceManager.createObject(
          "movie",
          "rightMaxChestGlow",
          `${this.name}:rightChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlow",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: 0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "rightMaxChestGlowGold",
          `${this.name}:rightChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlowGold",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: 0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
      };
      this._leftBonusMaxChestGlowAnims = {
        silver: resourceManager.createObject(
          "movie",
          "leftMaxChestGlow",
          `${this.name}:leftBonusChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlow",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: -0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "leftMaxChestGlowGold",
          `${this.name}:leftBonusChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlowGold",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: -0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
      };
      this._rightBonusMaxChestGlowAnims = {
        silver: resourceManager.createObject(
          "movie",
          "rightMaxChestGlow",
          `${this.name}:rightBonusChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlow",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: 0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
        gold: resourceManager.createObject(
          "movie",
          "rightMaxChestGlowGold",
          `${this.name}:rightBonusChestContainer:chestAnimationContainer`,
          {
            definition: "maxChestGlowGold",
            anchor: { x: 0.5, y: 1 },
            x: 0,
            y: 0,
            scaleX: 0.44,
            scaleY: 0.44,
            loop: true,
          }
        ),
      };

      this._leftMaxChestGlowAnims.silver.gotoAndPlay(0);
      this._leftMaxChestGlowAnims.gold.gotoAndPlay(0);
      this._rightMaxChestGlowAnims.silver.gotoAndPlay(0);
      this._rightMaxChestGlowAnims.gold.gotoAndPlay(0);
      this._leftBonusMaxChestGlowAnims.silver.gotoAndPlay(0);
      this._leftBonusMaxChestGlowAnims.gold.gotoAndPlay(0);
      this._rightBonusMaxChestGlowAnims.silver.gotoAndPlay(0);
      this._rightBonusMaxChestGlowAnims.gold.gotoAndPlay(0);
      this._leftMaxChestGlowAnims.silver.visible = false;
      this._leftMaxChestGlowAnims.gold.visible = false;
      this._rightMaxChestGlowAnims.silver.visible = false;
      this._rightMaxChestGlowAnims.gold.visible = false;
      this._leftBonusMaxChestGlowAnims.silver.visible = false;
      this._leftBonusMaxChestGlowAnims.gold.visible = false;
      this._rightBonusMaxChestGlowAnims.silver.visible = false;
      this._rightBonusMaxChestGlowAnims.gold.visible = false;

      gsap.to(
        [
          this._leftMaxChestGlowAnims.silver,
          this._leftMaxChestGlowAnims.gold,
          this._rightMaxChestGlowAnims.silver,
          this._rightMaxChestGlowAnims.gold,
          this._leftBonusMaxChestGlowAnims.silver,
          this._leftBonusMaxChestGlowAnims.gold,
          this._rightBonusMaxChestGlowAnims.silver,
          this._rightBonusMaxChestGlowAnims.gold,
        ],
        {
          duration: 0.8,
          alpha: 0.2,
          repeat: -1,
          yoyo: true,
          ease: "power2.inOut",
        }
      );
    }

    /**
     * Wiggle chest
     * @param {String} chestName - left/right
     */
    _wiggleChest(chestName, playSound = true) {
      this._wigglingChest = true;
      const tweenConfig = {
        firstRotate: { rotation: 0.15, duration: 0.1, ease: "power1.inOut" },
        secondRotate: { rotation: 0.15, duration: 0.2, ease: "power1.inOut" },
        centre: { rotation: 0, duration: 0.1, ease: "power1.inOut" },
      };

      if (chestName === "left") {
        tweenConfig.firstRotate.rotation *= -1;
      } else {
        tweenConfig.secondRotate.rotation *= -1;
      }

      const chest = this._getCurrentChestByName(chestName);
      const glow = this._getCurrentGlowByName(chestName);

      if (playSound) {
        soundManager.play("chestShake");
      }

      return gsap
        .timeline()
        .to([chest, glow], tweenConfig.firstRotate)
        .to([chest, glow], tweenConfig.secondRotate)
        .to([chest, glow], tweenConfig.centre)
        .call(() => {
          this._wigglingChest = false;
        });
    }

    /**
     * Get the chest depending on name
     * @param {String} chestName left/right
     */
    _getCurrentChestByName(chestName) {
      let chest;
      let chestColour;
      if (chestName === "left") {
        chestColour = this._chestColours[this._currentStates.left.colour];
        chest = this._leftChestAnimations[chestColour];
      } else if (chestName === "right") {
        chestColour = this._chestColours[this._currentStates.right.colour];
        chest = this._rightChestAnimations[chestColour];
      } else if (chestName === "leftBonus") {
        chestColour = this._chestColours[this._currentStates.leftBonus.colour];
        chest = this._leftBonusChestAnimations[chestColour];
      } else if (chestName === "rightBonus") {
        chestColour = this._chestColours[this._currentStates.rightBonus.colour];
        chest = this._rightBonusChestAnimations[chestColour];
      }
      return chest;
    }

    /**
     * Get the glow depending on name
     * @param {String} chestName left/right
     */
    _getCurrentGlowByName(chestName) {
      let glow;
      let glowColour;
      if (chestName === "left") {
        glowColour = this._chestColours[this._currentStates.left.colour];
        glow = this._leftMaxChestGlowAnims[glowColour];
      } else if (chestName === "right") {
        glowColour = this._chestColours[this._currentStates.right.colour];
        glow = this._rightMaxChestGlowAnims[glowColour];
      } else if (chestName === "leftBonus") {
        glowColour = this._chestColours[this._currentStates.leftBonus.colour];
        glow = this._leftBonusMaxChestGlowAnims[glowColour];
      } else if (chestName === "rightBonus") {
        glowColour = this._chestColours[this._currentStates.rightBonus.colour];
        glow = this._rightBonusMaxChestGlowAnims[glowColour];
      }
      return glow;
    }
    /**
     * Get the passive glow depending on name
     * @param {String} chestName left/right
     */
    _getPassiveGlowByName(chestName) {
      let glow;
      let glowColour;
      if (chestName === "left") {
        glowColour = this._chestColours[this._currentStates.left.colour === 0 ? 1 : 0];
        glow = this._leftMaxChestGlowAnims[glowColour];
      } else if (chestName === "right") {
        glowColour = this._chestColours[this._currentStates.right.colour === 0 ? 1 : 0];
        glow = this._rightMaxChestGlowAnims[glowColour];
      } else if (chestName === "leftBonus") {
        glowColour = this._chestColours[this._currentStates.leftBonus.colour === 0 ? 1 : 0];
        glow = this._leftBonusMaxChestGlowAnims[glowColour];
      } else if (chestName === "rightBonus") {
        glowColour = this._chestColours[this._currentStates.rightBonus.colour === 0 ? 1 : 0];
        glow = this._rightBonusMaxChestGlowAnims[glowColour];
      }
      return glow;
    }
    /**
     * Get the chest depending on name
     * @param {String} chestName left/right
     */
    _getPassiveChestByName(chestName) {
      const chests = [];
      let chestColour;
      if (chestName === "left") {
        chestColour = this._chestColours[this._currentStates.left.colour === 0 ? 1 : 0];
        chests.push(this._leftChestAnimations[chestColour]);
      } else {
        chestColour = this._chestColours[this._currentStates.right.colour === 0 ? 1 : 0];
        chests.push(this._rightChestAnimations[chestColour]);
      }
      return chests;
    }

    /**
     * Play the free spins awarded animation
     * @param {String} chestName
     */
    async playFreeSpinsAwarded(chestName, size, numFS) {
      let playFreeSpinsAwardedResolve;
      const playFreeSpinsAwardedPromise = new Promise((resolve) => {
        playFreeSpinsAwardedResolve = resolve;
      });

      const freespinAssetTweenConfig = {
        firstRotate: { rotation: 0.15, duration: 0.1, ease: "power1.inOut" },
        secondRotate: { rotation: 0.15, duration: 0.2, ease: "power1.inOut" },
        centre: { rotation: 0, duration: 0.1, ease: "power1.inOut" },
      };

      const chest = this._getCurrentChestByName(chestName);
      const glow = this._getCurrentGlowByName(chestName);

      // Start animating
      if (size) {
        await this._setSize(chestName, size, true);
      }

      let chestAssets;
      let freeSpinAsset;
      if (chestName === "left") {
        this._leftActive = true;
        chestAssets = this._leftChestAssets;
        freespinAssetTweenConfig.firstRotate.rotation *= -1;
        this._currentLeftFsAsset = freeSpinAsset = numFS === 6 ? chestAssets.sixFreeSpins : chestAssets.twelveFreeSpins;
      } else if (chestName === "right") {
        this._rightActive = true;
        chestAssets = this._rightChestAssets;
        freespinAssetTweenConfig.secondRotate.rotation *= -1;
        this._currentRightFsAsset = freeSpinAsset =
          numFS === 6 ? chestAssets.sixFreeSpins : chestAssets.twelveFreeSpins;
      } else if (chestName === "leftBonus") {
        this._leftBonusActive = true;
        chestAssets = this._leftBonusChestAssets;
        freespinAssetTweenConfig.secondRotate.rotation *= -1;
        this._currentLeftBonusFsAsset = freeSpinAsset = chestAssets[numFS];
      } else {
        this._rightBonusActive = true;
        chestAssets = this._rightBonusChestAssets;
        freespinAssetTweenConfig.secondRotate.rotation *= -1;
        this._currentRightBonusFsAsset = freeSpinAsset = chestAssets[numFS];
      }

      const burstAsset = chestAssets.burst;

      burstAsset.visible = true;

      // TO HANDLE ORIENTATION CHANGE
      chestAssets.burstShowing = true;

      soundManager.play("chestOpen");

      gsap
        .timeline()
        .call(() => {
          glow.visible = false;
        })
        .fromTo(burstAsset.scale, { x: 0.25, y: 0.25 }, { duration: 0.1, x: 1, y: 1 })
        .fromTo(burstAsset, { alpha: 0 }, { alpha: 1, duration: 0.1 }, "<")
        .to(burstAsset, {
          duration: 3,
          rotation: Math.PI * 2,
          repeat: -1,
        });

      // play the initial chest opening animation
      this._currentStates[chestName].size = 1;
      chest.animationSpeed = 0.5;
      chest.play();

      // play the freeSpin asset animations
      freeSpinAsset.visible = true;

      this[`_${chestName}FsAssetTween`] = gsap
        .timeline()
        .fromTo(
          freeSpinAsset.scale,
          {
            x: 0.3,
            y: 0.3,
          },
          {
            duration: 0.2,
            x: 0.6,
            y: 0.6,
          }
        )
        .to(freeSpinAsset.scale, {
          duration: 0.2,
          x: 1,
          y: 1,
        })
        .to(freeSpinAsset, { duration: 0.2, rotation: 0.3 }, "<")
        .call(() => {
          musicManager.playDevilLaughSound();
          playFreeSpinsAwardedResolve();
        })
        .to(freeSpinAsset, {
          duration: 0.4,
          rotation: -0.3,
          yoyo: true,
          repeat: -1,
          ease: "sine.inOut",
        });

      await playFreeSpinsAwardedPromise;
    }

    /**
     * Finish awarding free from (animate from the chest)
     */
    async finishAwardingFreeSpins() {
      let finishAwardingFreeSpinsPromise = [];

      if (this._leftActive) {
        const chest = this._getCurrentChestByName("left");
        this._leftFsAssetTween.kill();
        const leftPromise = this.finishAwardingFreeSpinsTween(this._currentLeftFsAsset);
        finishAwardingFreeSpinsPromise.push(leftPromise);

        chest.animationSpeed = -0.5;
        chest.play();
        chest.onComplete = async () => {
          this.resetChest("left").then(() => (chest.onComplete = null));
        };
        gsap.to(this._leftChestAssets.burst, {
          alpha: 0,
          duration: 0.5,
          onComplete: () => (this._leftChestAssets.burstShowing = false),
        });
      }

      if (this._rightActive) {
        const chest = this._getCurrentChestByName("right");
        this._rightFsAssetTween.kill();
        const rightPromise = this.finishAwardingFreeSpinsTween(this._currentRightFsAsset);
        finishAwardingFreeSpinsPromise.push(rightPromise);

        chest.animationSpeed = -0.5;
        chest.play();
        chest.onComplete = async () => {
          this.resetChest("right").then(() => (chest.onComplete = null));
        };
        gsap.to(this._rightChestAssets.burst, {
          alpha: 0,
          duration: 0.5,
          onComplete: () => (this._rightChestAssets.burstShowing = false),
        });
      }

      if (this._leftBonusActive) {
        const chest = this._getCurrentChestByName("leftBonus");
        const glow = this._getCurrentGlowByName("leftBonus");
        this._leftBonusFsAssetTween.kill();
        const bonusPromise = this.finishAwardingFreeSpinsTween(this._currentLeftBonusFsAsset);
        finishAwardingFreeSpinsPromise.push(bonusPromise);

        chest.animationSpeed = -0.5;
        chest.play();
        gsap.to(this._leftBonusChestAssets.burst, {
          alpha: 0,
          duration: 1,
          onComplete: () => {
            glow.visible = true;
            this._leftBonusChestAssets.burstShowing = false;
          },
        });
      }

      if (this._rightBonusActive) {
        const chest = this._getCurrentChestByName("rightBonus");
        const glow = this._getCurrentGlowByName("rightBonus");
        this._rightBonusFsAssetTween.kill();
        const bonusPromise = this.finishAwardingFreeSpinsTween(this._currentRightBonusFsAsset);
        finishAwardingFreeSpinsPromise.push(bonusPromise);

        chest.animationSpeed = -0.5;
        chest.play();

        gsap.to(this._rightBonusChestAssets.burst, {
          alpha: 0,
          duration: 1,
          onComplete: () => {
            glow.visible = true;
            this._rightBonusChestAssets.burstShowing = false;
          },
        });
      }

      await Promise.all(finishAwardingFreeSpinsPromise);

      this._currentLeftFsAsset = null;
      this._currentRightFsAsset = null;
      this._leftActive = this._rightActive = this._leftBonusActive = this._rightBonusActive = false;
      this._rightFsAssetTween =
        this._leftFsAssetTween =
        this._leftBonusFsAssetTween =
        this._rightBonusFsAssetTween =
          null;
    }

    /**
     * Finish awarding free spins retrigger
     */
    async finishAwardingRetrigger(spinsAwarded) {
      let finishAwardingFreeSpinsPromise = [];

      if (this._leftActive) {
        const chest = this._getCurrentChestByName("left");
        this._leftFsAssetTween.kill();
        const leftPromise = this.finishAwardingFreeSpinsTween(this._currentLeftFsAsset);
        finishAwardingFreeSpinsPromise.push(leftPromise);

        chest.animationSpeed = -0.5;
        chest.play();
        chest.onComplete = async () => {
          this.resetChest("left").then(() => (chest.onComplete = null));
        };
        gsap.to(this._leftChestAssets.burst, {
          alpha: 0,
          duration: 0.5,
          onComplete: () => (this._leftChestAssets.burstShowing = false),
        });
      }

      if (this._rightActive) {
        const chest = this._getCurrentChestByName("right");
        this._rightFsAssetTween.kill();
        const rightPromise = this.finishAwardingFreeSpinsTween(this._currentRightFsAsset);
        finishAwardingFreeSpinsPromise.push(rightPromise);

        chest.animationSpeed = -0.5;
        chest.play();
        chest.onComplete = async () => {
          this.resetChest("right").then(() => (chest.onComplete = null));
        };
        gsap.to(this._rightChestAssets.burst, {
          alpha: 0,
          duration: 0.5,
          onComplete: () => (this._rightChestAssets.burstShowing = false),
        });
      }
      if (this._leftBonusActive) {
        const chest = this._getCurrentChestByName("leftBonus");
        const glow = this._getCurrentGlowByName("leftBonus");
        this._leftBonusFsAssetTween.kill();
        const bonusPromise = this.finishAwardingFreeSpinsTween(this._currentLeftBonusFsAsset);
        finishAwardingFreeSpinsPromise.push(bonusPromise);

        chest.animationSpeed = -0.5;
        chest.play();
        gsap.to(this._leftBonusChestAssets.burst, {
          alpha: 0,
          duration: 0.5,
          onComplete: () => {
            glow.visible = true;
            this._leftBonusChestAssets.burstShowing = false;
          },
        });
      }
      if (this._rightBonusActive) {
        const chest = this._getCurrentChestByName("rightBonus");
        const glow = this._getCurrentGlowByName("rightBonus");
        this._rightBonusFsAssetTween.kill();
        const bonusPromise = this.finishAwardingFreeSpinsTween(this._currentRightBonusFsAsset);
        finishAwardingFreeSpinsPromise.push(bonusPromise);

        chest.animationSpeed = -0.5;
        chest.play();
        gsap.to(this._rightBonusChestAssets.burst, {
          alpha: 0,
          duration: 0.5,
          onComplete: () => {
            glow.visible = true;
            this._rightBonusChestAssets.burstShowing = false;
          },
        });
      }

      await Promise.all(finishAwardingFreeSpinsPromise);

      this._currentLeftFsAsset = null;
      this._currentRightFsAsset = null;
      this._currentLeftBonusFsAsset = null;
      this._currentRightBonusFsAsset = null;
      this._leftActive = this._rightActive = this._leftBonusActive = this._rightBonusActive = false;
      this._rightFsAssetTween =
        this._leftFsAssetTween =
        this._leftBonusFsAssetTween =
        this._rightBonusFsAssetTween =
          null;

      await this.showRetriggerPopup(spinsAwarded);
    }

    /**
     * Show retrigger popup
     */
    async showRetriggerPopup(spinsAwarded) {
      resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro").visible = true;

      resourceManager.getContainer("gambleIntroContainer").visible = true;
      resourceManager.get("gambleBacker").alpha = 0;
      resourceManager.get("gambleBacker").visible = true;

      await new Promise((resolve) => {
        gsap
          .timeline()
          .call(() => {
            this._retriggerPopup.alpha = 0;
            this._retriggerPopup.visible = true;
            this._spinsAwarded.setText(spinsAwarded);
            musicManager.popupEnter();
          })
          .to(this._retriggerPopup, {
            duration: 0.8,
            alpha: 1,
          })
          .to(this._retriggerPopup, {
            delay: 1,
            duration: 0.8,
            alpha: 0,
            onComplete: resolve,
          });
      });
    }

    /**
     * Tween for finishing free spins
     */
    async finishAwardingFreeSpinsTween(freeSpinAsset) {
      await gsap.to(freeSpinAsset, {
        duration: 1,
        rotation: Math.PI * 2,
        alpha: 0,
        ...this.getCentreLocation(freeSpinAsset),
      });
      freeSpinAsset.x = 0;
      freeSpinAsset.y = 0;
      freeSpinAsset.visible = false;
      freeSpinAsset.alpha = 1;
      freeSpinAsset.rotation = 0;
    }

    /**
     * Get the relative center location of any asset
     * @param {*} asset
     * @returns {x: number, y: number}
     */
    getCentreLocation(asset) {
      const globalPos = resourceManager.get("slotContainer:reelContainer:reel7").getGlobalPosition();
      const localPos = asset.parent.toLocal(globalPos);
      return { x: localPos.x, y: localPos.y };
    }

    setInitialState({ leftChestColour, leftChestSize, rightChestColour, rightChestSize }) {
      this.setState({
        leftChestColour,
        leftChestSize,
        rightChestColour,
        rightChestSize,
      });

      this._setSize("left", leftChestSize);
      this._setSize("right", rightChestSize);
      this._setChestColour("left");
      this._setChestColour("right");
    }

    setState({ leftChestColour, leftChestSize, rightChestColour, rightChestSize }) {
      if (leftChestColour !== null && leftChestColour !== undefined) this._currentStates.left.colour = leftChestColour;
      if (leftChestSize !== null && leftChestSize !== undefined) this._currentStates.left.size = leftChestSize;
      if (rightChestColour !== null && rightChestColour !== undefined && !gameData.encoreEnabled)
        this._currentStates.right.colour = rightChestColour;
      if (rightChestSize !== null && rightChestSize !== undefined) this._currentStates.right.size = rightChestSize;

      const leftChest = gameController.inBuyABonus ? "leftBonus" : "left";
      const rightChest = gameController.inBuyABonus ? "rightBonus" : "right";

      if (gameController.inBuyABonus) {
        leftChestSize = 5;
        rightChestSize = 5;
      }

      this._setChestColour(leftChest);
      this._setSize(leftChest, leftChestSize, false);
      if (!gameData.encoreEnabled) {
        this._setChestColour(rightChest);
      }
      this._setSize(rightChest, rightChestSize, false);
    }

    /**
     * Set the chest colour to either silver or gold (0, 1)
     * @param {String} chestName left/right
     */
    _setChestColour(chestName) {
      const chestStateMap = {
        left: this._currentStates.left,
        right: this._currentStates.right,
        leftBonus: this._currentStates.leftBonus,
        rightBonus: this._currentStates.rightBonus,
      };

      const chestAnimationsMap = {
        left: this._leftChestAnimations,
        right: this._rightChestAnimations,
        leftBonus: this._leftBonusChestAnimations,
        rightBonus: this._rightBonusChestAnimations,
      };

      const chestState = chestStateMap[chestName];
      const chestAnimations = chestAnimationsMap[chestName];

      if (chestAnimations.silver) {
        chestAnimations.silver.visible = chestState.colour === 0;
      }
      if (chestAnimations.gold) {
        chestAnimations.gold.visible = chestState.colour !== 0;
      }
    }

    /**
     * Show the bonus chest in buy a bonus and hide normal chests
     */
    _showBonusChest(show, level) {
      resourceManager.get("chestsContainer:leftChestContainer:chestAnimationContainer").visible = !show;
      resourceManager.get("chestsContainer:rightChestContainer:chestAnimationContainer").visible = !show;
      resourceManager.get("chestsContainer:leftBonusChestContainer:chestAnimationContainer").visible = show;
      resourceManager.get("chestsContainer:rightBonusChestContainer:chestAnimationContainer").visible = show;
      if (level !== undefined) {
        this._leftBonusChestAnimations.silver.visible = level === 0;
        this._leftBonusChestAnimations.gold.visible = level !== 0;
        this._leftBonusMaxChestGlowAnims.silver.visible = level === 0;
        this._leftBonusMaxChestGlowAnims.gold.visible = level !== 0;
        this._currentStates.leftBonus.colour = level;

        this._rightBonusChestAnimations.silver.visible = level === 0;
        this._rightBonusChestAnimations.gold.visible = level !== 0;
        this._rightBonusMaxChestGlowAnims.silver.visible = level === 0;
        this._rightBonusMaxChestGlowAnims.gold.visible = level !== 0;
        this._currentStates.rightBonus.colour = level;
      }
    }

    /**
     * Set the chest colour to either silver or gold (0, 1)
     * @param {String} chestName left/right
     * @param {String} colour
     */
    _openBonusChest() {
      //if isOpened, open chest and show spins in chest
    }

    /**
     * Increase the size of a chest
     * @param {String} chestName - left right
     * @param {Number} size - passed from data
     */
    _setSize(chestName, size, staggeredIncrease = false) {
      if (size === undefined) {
        return Promise.resolve();
      }

      return new Promise(async (res) => {
        if (size) {
          const chest = this._getCurrentChestByName(chestName);
          const passiveChests = this._getPassiveChestByName(chestName);
          const glow = this._getCurrentGlowByName(chestName);
          const passiveGlow = this._getPassiveGlowByName(chestName);
          if (size !== 5) {
            glow.visible = false;
            passiveGlow.visible = false;
          }

          let currentSize;
          currentSize = this._currentStates[chestName].size;

          if (chest === null || chest === undefined) {
            return;
          }

          passiveChests.forEach((passiveChest) => {
            passiveChest.scale.x =
              chestName.indexOf("left") !== -1 ? this._sizeScales[size] * -1 : this._sizeScales[size];
            passiveChest.scale.y = this._sizeScales[size];
          });

          const sizeIncreaseTimeline = gsap.timeline({ onComplete: res });
          if (staggeredIncrease) {
            // check if sizing up
            if (size > currentSize) {
              for (let i = currentSize + 1; i <= size; i++) {
                const scaleSize = this._sizeScales[i];
                sizeIncreaseTimeline
                  .call(() => musicManager.playChestExpandSound(i))
                  .to(chest.scale, {
                    x: chestName.indexOf("left") !== -1 ? scaleSize * -1 : scaleSize,
                    y: scaleSize,
                    duration: 0.5,
                    onComplete: () => {
                      this._currentStates[chestName].size = i;
                      if (size === 5 && i === size) {
                        glow.visible = true;
                      }
                    },
                  });
                if (i < size) {
                  sizeIncreaseTimeline.to(
                    {
                      /** delay */
                    },
                    { duration: 0.6 }
                  );
                }
              }
            } else if (size < currentSize) {
              for (let i = currentSize - 1; i >= size; i--) {
                this._currentStates[chestName].size = i;
                const scaleSize = this._sizeScales[i];
                sizeIncreaseTimeline.to(chest.scale, {
                  x: chestName.indexOf("left") !== -1 ? scaleSize * -1 : scaleSize,
                  y: scaleSize,
                  duration: 0.5,
                });
                if (i > size) {
                  sizeIncreaseTimeline.to(
                    {
                      /** delay */
                    },
                    { duration: 0.6 }
                  );
                }
              }
            }
          } else {
            if (size === 5) {
              glow.visible = true;
            }
            this._currentStates[chestName].size = size;
            const scaleSize = this._sizeScales[size];
            chest.scale.x = chestName.indexOf("left") !== -1 ? scaleSize * -1 : scaleSize;
            chest.scale.y = scaleSize;
            res();
          }
        }
      });
    }

    /**
     * Toggle golden bet on or off for right chest
     * @param {boolean} isOn
     */
    toggleGoldenBet(isOn) {
      if (isOn) {
        if (this._currentStates.right.colour === 0) {
          if (this._currentStates.right.size === 5) {
            const glow = this._getCurrentGlowByName("right");
            glow.visible = false;
          }
          this._currentStates.right.colour = 1;
          this._currentStates.right.silverBeforeGB = true;
          this._setChestColour("right");
          if (this._currentStates.right.size === 5) {
            const glow = this._getCurrentGlowByName("right");
            glow.visible = true;
          }
          return true;
        }
      } else {
        if (this._currentStates.right.silverBeforeGB) {
          if (this._currentStates.right.size === 5) {
            const glow = this._getCurrentGlowByName("right");
            glow.visible = false;
          }
          this._currentStates.right.colour = 0;
          this._currentStates.right.silverBeforeGB = false;
          this._setChestColour("right");
          if (this._currentStates.right.size === 5) {
            const glow = this._getCurrentGlowByName("right");
            glow.visible = true;
          }
          return false;
        }
      }
    }

    /**
     * Reset a chest to its original size
     * @param {String} chestName left/right
     */
    async resetChest(chestName) {
      const chest = this._getCurrentChestByName(chestName);
      const passiveChests = this._getPassiveChestByName(chestName);
      let leftChestSize = chestName === "left" ? 1 : undefined;
      let rightChestSize = chestName === "right" ? 1 : undefined;
      let leftChestColour = gameController.inBuyABonus
        ? this._currentStates["leftBonus"].colour
        : this._currentStates["left"].colour;
      let rightChestColour = gameController.inBuyABonus
        ? this._currentStates["rightBonus"].colour
        : this._currentStates["right"].colour;
      if (gameController.treasureChestClose != undefined) {
        if (gameController.treasureChestClose.left.hasBeenClosed) {
          leftChestColour = gameController.treasureChestClose.left.newColour;
        }
        if (!gameData.encoreEnabled) {
          if (gameController.treasureChestClose.right.hasBeenClosed) {
            rightChestColour = gameController.treasureChestClose.right.newColour;
          }
        }
      }
      this.setState({ leftChestColour, leftChestSize, rightChestColour, rightChestSize });
      passiveChests.forEach((passiveChest) => {
        passiveChest.scale.x = chestName === "left" || chestName === "leftBonus" ? -0.3 : 0.3;
        passiveChest.scale.y = 0.3;
      });

      await gsap.to(chest.scale, {
        x: chestName === "left" || chestName === "leftBonus" ? -0.3 : 0.3,
        y: 0.3,
        duration: 1,
      });

      this._currentStates[chestName].size = 1;
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {
      if (!game.splashScreenDone) {
        return;
      }
      this.setInitialState({
        leftChestColour: this._currentStates.left.colour,
        leftChestSize: this._currentStates.left.size,
        rightChestColour: this._currentStates.right.colour,
        rightChestSize: this._currentStates.right.size,
      });

      if (this._currentLeftFsAsset) {
        this._currentLeftFsAsset.visible = true;
        this._currentLeftFsAsset.scale.set(0.6);
        this._leftChestAssets.burst.visible = true;

        if (this._leftChestAssets.burstShowing) {
          this._leftChestAssets.burst.alpha = 1;
        }
      }
      if (this._currentRightFsAsset) {
        this._currentRightFsAsset.visible = true;
        this._currentRightFsAsset.scale.set(0.6);
        this._rightChestAssets.burst.visible = true;

        if (this._rightChestAssets.burstShowing) {
          this._rightChestAssets.burst.alpha = 1;
        }
      }
      if (this._currentLeftBonusFsAsset) {
        this._currentLeftBonusFsAsset.visible = true;
        this._currentLeftBonusFsAsset.scale.set(0.6);
        this._leftBonusChestAssets.burst.visible = true;
        if (this._leftBonusChestAssets.burstShowing) {
          this._leftBonusChestAssets.burst.alpha = 1;
        }
      }

      if (this._currentRightBonusFsAsset) {
        this._currentRightBonusFsAsset.visible = true;
        this._currentRightBonusFsAsset.scale.set(0.6);
        this._rightBonusChestAssets.burst.visible = true;
        if (this._rightBonusChestAssets.burstShowing) {
          this._rightBonusChestAssets.burst.alpha = 1;
        }
      }
    }
  }

  resourceManager.registerObjectType(
    "chests",
    () => new Chests(),
    () => {},
    () => []
  );
})();
